import styled from "styled-components";

const CardContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color:  #2828284D;
  border-radius: ${(props) => props.theme.borderRadius || "100px"};
  box-shadow: ${(props) => props.theme.shadows.card || "0 4px 10px rgba(0,0,0,0.1)"};
  padding: ${(props) => props.theme.spacing(2)};
  transition: all 0.3s ease-in-out;
  width: 100%;
  backdrop-filter: blur(30px);
  border: 1px solid #7556BF;
`;

const LeftSection = styled.div`
  display: flex;
  align-items: center;
  gap: ${(props) => props.theme.spacing(1)};
`;

const TokenLogo = styled.img`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  object-fit: cover;
`;

const TokenDetails = styled.div`
  display: flex;
  flex-direction: column;
`;

const TokenName = styled.h3`
  font-size: 1.2rem;
  color: ${(props) => props.theme.colors.text.light || "#333"};
  margin: 0;
`;

const TokenPrice = styled.p`
  font-size: 0.9rem;
  color: ${(props) => props.theme.colors.secondaryText || "#777"};
  margin: 0;
`;

const RightSection = styled.div`
  text-align: right;
`;

const Balance = styled.p`
  font-size: 1.1rem;
  font-weight: bold;
  color: ${(props) => props.theme.colors.text.light || "#333"};
  margin: 0;
`;

const BalanceUSD = styled.p`
  font-size: 0.9rem;
  color: ${(props) => props.theme.colors.secondaryText || "#777"};
  margin: 0;
`;

const TokenCard = ({ logo, name, price, balance, balanceUSD }) => {
  const formatNumber = (num,decimals = 2) => {
    if(num === undefined) return "0.00";
    if(typeof num === "string") num = parseFloat
    return num.toLocaleString(undefined, {
      minimumFractionDigits: decimals,
      maximumFractionDigits: decimals,
    });
  };
  
  return (
    <CardContainer>
      <LeftSection>
        <TokenLogo src={logo} alt={`${name} logo`} />
        <TokenDetails>
          <TokenName>{name}</TokenName>
          <TokenPrice>${formatNumber(price,8)}</TokenPrice>
        </TokenDetails>
      </LeftSection>
      <RightSection>
        <Balance>{formatNumber(balance)}</Balance>
        <BalanceUSD>${formatNumber(balanceUSD,6)}</BalanceUSD>
      </RightSection>
    </CardContainer>
  );
};

export default TokenCard;
